import ReactQuill from "react-quill";
import React, { useContext } from "react";
import constants from "../../../constants";
import UploadButton from "../../UploadButton";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../../util";
import BackSvgIcon from "../../../Svg/BackSvgIcon";
import DataTable from "react-data-table-component";
import AlertContext from "../../../context/AlertContext";
import ComplexityLabels from "../../CommonComponents/ComplexityLabels";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";

export default function SQLProblem() {
  const Alert = useContext(AlertContext);

  const CodingHeaderLearnerSideHks = CodingHeaderLearnerSideHooks();

  const { pathname } = useLocation();

  const handleBack = () => {
    if (
      Alert.isFromProfile.current ||
      getDataFromStorage("role") === "customer"
    ) {
      Alert.navigate("/profiles/testpoints");
    } else {

      if(getDataFromStorage("role") === "learner" && Alert.testData.testmode === constants.MODE.PRACTICE_MODE && Alert.status !== constants.QUESTION_STATUS.SUBMITTED){
              CodingHeaderLearnerSideHks.saveCurrentAnswer();
      }
      Alert.setFromCodeEditor(true);

      if (document.fullscreenElement) {
        document.exitFullscreen();
      }

      if (Alert.isAdmin) {
        localStorage.removeItem("splitPos");
        localStorage.removeItem("splitWidthPos");
        Alert.setLpId(Alert.lpId);
        Alert.setStatus("");

        if (Alert.showBreadCrumbsData?.from === "user") {
          Alert.setShowPopup(true);
          Alert.navigate(`batches/${sessionStorage.getItem("abatchid")}/users`);
        } else if (Alert.showBreadCrumbsData?.from === "old") {
          Alert.navigate(
            `batches/${sessionStorage.getItem("abatchid")}/report`
          );
        } else {
          Alert.navigate(
            `batches/${sessionStorage.getItem(
              "abatchid"
            )}/path/${sessionStorage.getItem("aPathId")}/report#`
          );
        }
      } else if (Alert.testData.mockuse) {
        Alert.navigate("main/mock/results");
      } else if (Alert.testData.single) {
        Alert.navigate(`/main/cc/section/${Alert.testData.secid}`);
      } else if (Alert.showBreadCrumbsData?.from === "learner") {
        Alert.navigate("/main/dashboard/testresults");
      } else {
        Alert.setLpData({});
        Alert.navigate("/home");
      }
    }
  };

  const columns = [
    { name: "Type", selector: (row) => row.type },
    { name: "Column Name", selector: (row) => row.column_name },
  ];

  return (
    <div className="sqlPageProblemMainContainer">
      {((Alert.isAdmin && !pathname.includes("library")) ||
        (!Alert.isAdmin &&
          (Alert.status === constants.QUESTION_STATUS.SUBMITTED ||
            Alert.status === constants.QUESTION_STATUS.TO_BE_EVALUATED ||
            Alert.testData.testmode === constants.MODE.PRACTICE_MODE || Alert?.showBreadCrumbsData?.from ==="learner"))) &&(
        <BackSvgIcon component="codingProblem" onClick={handleBack} />
      )}
      <div className="sqlPageProblemHeader">
        <div className="sqlPageProblemQuestionDiv">
          <ReactQuill
            readOnly={true}
            value={Alert.testDetail?.name}
            className="sqlPageProblemReactQuill"
          />
          <ComplexityLabels
            complexityid={
              Alert.testDetail?.complexity || Alert.testDetail?.complexityid
            }
          />
        </div>
        <ReactQuill
          readOnly={true}
          className="sqlPageProblemReactQuill"
          value={Alert.testDetail?.description}
        />
        {pathname.includes("library") && <UploadButton />}
      </div>
      <div className="sqlPageProblemTableDiv">
        <div className="sqlPageProblemTableDivHeader">
          Go through the following tables below to understand the problem
          better:
        </div>
        <div className="sqlPageProblemTableDivBody">
          {Alert.testDetail?.schema &&
            Alert.testDetail?.schema.map((table, index) => (
              <div key={index}>
                <div className="sqlPageProblemTableName">
                  Table : {table.tableName}
                </div>
                <DataTable
                  striped
                  responsive
                  highlightOnHover
                  columns={columns}
                  data={table.columns}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
